// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3k5IN","fullView":"styles_fullView__2dDtu"};